import type {PostSchema} from '../../../core/entities/columns/schema';

export const isSponsored = (post: PostSchema) => {
  return (
    post.category === 'sponsored' && post.subCategory === 'interview_sponsored'
  );
};
